import { CLEAR_ALL, LOGOUT } from '../../../store/Types';

export const ALL_MATERIAS = 'ALL_MATERIAS';
export const LOADING_ALL_MATERIAS = 'LOADING_ALL_MATERIAS';
export const ACTIVO_MATERIAS = 'ACTIVO_MATERIAS';
export const ALERT_VIEW_MATERIAS = 'ALERT_VIEW_MATERIAS';
export const ALERT_FORM_MATERIAS = 'ALERT_FORM_MATERIAS';
export const PARAMS_MATERIAS = 'PARAMS_MATERIAS';
export const SEARCH_MATERIAS = 'SEARCH_MATERIAS';

const initialState = {
  all: [],
  loadingAll: false,
  search: [],
  activo: null,
  params: {},
  alertView: null,
  alertForm: null,
};

export const operadorasReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_MATERIAS:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case LOADING_ALL_MATERIAS:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case ACTIVO_MATERIAS:
      return {
        ...state,
        activo: action.payload,
      };
    case ALERT_VIEW_MATERIAS:
      return {
        ...state,
        alertView: action.payload,
      };
    case ALERT_FORM_MATERIAS:
      return {
        ...state,
        alertForm: action.payload,
      };
    case SEARCH_MATERIAS:
      return {
        ...state,
        search: action.payload,
      };
    case PARAMS_MATERIAS:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
